var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35570",
    "data-name": "Group 35570",
    transform: "translate(-31 -464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27153",
    "data-name": "Group 27153",
    transform: "translate(31 464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    d: "M14,2.1A11.9,11.9,0,0,0,5.585,22.415,11.9,11.9,0,0,0,22.415,5.585,11.822,11.822,0,0,0,14,2.1M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(0)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39512",
    "data-name": "Path 39512",
    d: "M1.63,0V-5.36L.18-4.78v-1.4L2.23-7H3.25V0Z",
    transform: "translate(42.82 481.5)",
    fill: "#1c1c1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.0e174d2a51cb97584d97de5f50ed8e42.svg";
export { ForwardRef as ReactComponent };